import React from 'react';

import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export const columns = [
  {
    title: "Due Diligence Compliance Plan",
    dataIndex: 'name',
    key: 'name',
    colSpan: 1,
  },
  {
    title: "Completion",
    dataIndex: 'completion',
    className: 'text-center',
    key: 'completion',
    colSpan: 1,
    render: value => {
      if (typeof value === 'boolean') {
        return <CheckOutlined style={{ color: "#23af52" }} />
      }
      return <span style={{ color: "#23af52" }}>{value}%</span>
    }
  },
  {
    title: "Last Update",
    dataIndex: 'lastUpdate',
    className: 'text-center',
    key: 'lastUpdate',
    colSpan: 1,
  },
  {
    title: "Next Due Date",
    dataIndex: 'nextDueDate',
    className: 'text-center',
    key: 'nextDueDate',
    colSpan: 1,
  },
  {
    title: 'Actions',
    key: 'actions',
    colSpan: 1,
    render: () => <Button size="small" type="primary">Details</Button>
  }
];

export const data = [
  {
    key: '1',
    name: 'OECD 1A - Supply Chain Policy Summary',
    completion: true,
    lastUpdate: '01-Feb-2020',
    nextDueDate: '01-Feb-2021',
  },
  {
    key: '2',
    name: 'OECD 1B - Internal Management Systems Summary',
    completion: true,
    lastUpdate: '03-Feb-2020',
    nextDueDate: '03-Feb-2021',
  },
  {
    key: '3',
    name: 'OECD 1C - Supply Chain Integrity Systems Summary',
    completion: true,
    lastUpdate: '12-Apr-2020',
    nextDueDate: '12-Apr-2021',
  },
  {
    key: '4',
    name: 'OECD 1D - Business Partners Engagement Summary',
    completion: true,
    lastUpdate: '22-Feb-2020',
    nextDueDate: '22-Feb-2021',
  },
  {
    key: '5',
    name: 'OECD 1E - Grievance Mechanism Summary',
    completion: true,
    lastUpdate: '12-Apr-2020',
    nextDueDate: '12-Apr-2021',
  },
];

const all = {
  columns,
  data,
}
export default all;
